import { render, staticRenderFns } from "./PhysicalTestList.vue?vue&type=template&id=c13b91b0&scoped=true"
import script from "./PhysicalTestList.vue?vue&type=script&lang=js"
export * from "./PhysicalTestList.vue?vue&type=script&lang=js"
import style0 from "./PhysicalTestList.vue?vue&type=style&index=0&id=c13b91b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../Vue/course_selecttion_v3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b91b0",
  null
  
)

export default component.exports